const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const weekDay = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const getMonth = (date) => {
  let formattedDate = new Date(date);
  return month[formattedDate?.getMonth()];
};
export const getWeekDay = (date) => {
  let formattedDate = new Date(date);
  return weekDay[formattedDate?.getDay()];
};
export const getYear = (date) => {
  let formattedDate = new Date(date);
  return formattedDate?.getFullYear();
};
export const getDate = (date) => {
  let formattedDate = new Date(date);
  return formattedDate?.getDate();
};
